'use strict';

module.exports = function () {
  for (var _len = arguments.length, selectors = Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  var i, len, selector, tag;
  tag = null;
  for (i = 0, len = selectors.length; i < len; i++) {
    selector = selectors[i];
    tag = document.querySelector(selector) || document.querySelector('[riot-tag="' + selector + '"]');
    if (tag != null) {
      break;
    }
  }
  return tag;
};